import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useContext } from 'react';
import Button from '../../Button';
import Chip from '../../Chip';
import ProgressBar from '../../ProgressBar';
import { Styled } from './Header.styles';
import { WizardContext } from '../Wizard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var useWizardContext = function useWizardContext() {
  return useContext(WizardContext);
};

var Header = forwardRef(function (_ref, ref) {
  var _chip$label, _chip$status, _chip$hasStatusLight, _tertiaryAction$icon, _tertiaryAction$isDis, _tertiaryAction$isLoa, _tertiaryAction$varia, _secondaryAction$icon, _secondaryAction$isDi, _secondaryAction$isLo, _secondaryAction$vari, _secondaryAction$labe, _primaryAction$icon, _primaryAction$isDisa, _primaryAction$isLoad, _primaryAction$varian, _primaryAction$label;

  var rest = _extends({}, _ref);

  var _useWizardContext = useWizardContext(),
      headerActions = _useWizardContext.headerActions,
      activeStepProps = _useWizardContext.activeStepProps,
      activeStepIndex = _useWizardContext.activeStepIndex,
      chip = _useWizardContext.chip,
      stepSeparator = _useWizardContext.stepSeparator,
      customStepCount = _useWizardContext.customStepCount,
      customStepIndex = _useWizardContext.customStepIndex,
      legacyOnCancel = _useWizardContext.legacyOnCancel,
      legacyOnSubmit = _useWizardContext.legacyOnSubmit,
      legacySubmitButtonLabel = _useWizardContext.legacySubmitButtonLabel,
      legacyCancelButtonLabel = _useWizardContext.legacyCancelButtonLabel,
      stepCount = _useWizardContext.stepCount,
      title = _useWizardContext.title;

  var totalStepCount = customStepCount ? customStepCount : stepCount;
  var stepIndex = customStepIndex ? customStepIndex : activeStepIndex + 1;
  var progressPercentage = (stepIndex / totalStepCount * 100).toFixed(0);
  var chipLabel = (_chip$label = chip === null || chip === void 0 ? void 0 : chip.label) !== null && _chip$label !== void 0 ? _chip$label : null;
  var chipStatus = (_chip$status = chip === null || chip === void 0 ? void 0 : chip.status) !== null && _chip$status !== void 0 ? _chip$status : 'default';
  var chipHasStatusLight = (_chip$hasStatusLight = chip === null || chip === void 0 ? void 0 : chip.hasStatusLight) !== null && _chip$hasStatusLight !== void 0 ? _chip$hasStatusLight : false;
  var primaryAction = headerActions.primary;
  var secondaryAction = headerActions.secondary;
  var tertiaryAction = headerActions.tertiary;
  return _jsxs(Styled.Header, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [totalStepCount > 1 && _jsx(ProgressBar, {
      value: progressPercentage,
      size: "small"
    }), _jsxs(Styled.HeaderInner, {
      children: [totalStepCount > 1 && _jsxs(Styled.StepCounter, {
        children: [customStepIndex ? customStepIndex : activeStepIndex + 1, _jsx("span", {
          children: stepSeparator
        }), totalStepCount]
      }), _jsxs(Styled.StepHeading, {
        children: [_jsx(Styled.StepMeta, {
          children: title
        }), _jsxs(Styled.StepTitle, {
          children: [_jsx("h2", {
            children: activeStepProps.title
          }), chipLabel && _jsx(Chip, {
            variant: "status",
            status: chipStatus,
            hasStatusLight: chipHasStatusLight,
            children: chipLabel
          })]
        })]
      }), _jsxs(Styled.StepActions, {
        children: [tertiaryAction && !tertiaryAction.isHidden && _jsx(Button, {
          iconLeft: (_tertiaryAction$icon = tertiaryAction === null || tertiaryAction === void 0 ? void 0 : tertiaryAction.icon) !== null && _tertiaryAction$icon !== void 0 ? _tertiaryAction$icon : null,
          isDisabled: (_tertiaryAction$isDis = tertiaryAction === null || tertiaryAction === void 0 ? void 0 : tertiaryAction.isDisabled) !== null && _tertiaryAction$isDis !== void 0 ? _tertiaryAction$isDis : false,
          isLoading: (_tertiaryAction$isLoa = tertiaryAction === null || tertiaryAction === void 0 ? void 0 : tertiaryAction.isLoading) !== null && _tertiaryAction$isLoa !== void 0 ? _tertiaryAction$isLoa : false,
          onClick: function onClick() {
            if (legacyOnCancel) {
              legacyOnCancel();
            } else if (tertiaryAction.onClick) {
              tertiaryAction.onClick();
            } else {
              return null;
            }
          },
          variant: (_tertiaryAction$varia = tertiaryAction === null || tertiaryAction === void 0 ? void 0 : tertiaryAction.variant) !== null && _tertiaryAction$varia !== void 0 ? _tertiaryAction$varia : 'tertiary',
          children: tertiaryAction.label
        }), secondaryAction && !secondaryAction.isHidden && _jsx(Button, {
          iconLeft: (_secondaryAction$icon = secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.icon) !== null && _secondaryAction$icon !== void 0 ? _secondaryAction$icon : null,
          isDisabled: (_secondaryAction$isDi = secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.isDisabled) !== null && _secondaryAction$isDi !== void 0 ? _secondaryAction$isDi : false,
          isLoading: (_secondaryAction$isLo = secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.isLoading) !== null && _secondaryAction$isLo !== void 0 ? _secondaryAction$isLo : false,
          onClick: function onClick() {
            if (legacyOnCancel) {
              legacyOnCancel();
            } else if (secondaryAction.onClick) {
              secondaryAction.onClick();
            } else {
              return null;
            }
          },
          variant: (_secondaryAction$vari = secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.variant) !== null && _secondaryAction$vari !== void 0 ? _secondaryAction$vari : 'tertiary',
          children: legacyCancelButtonLabel || ((_secondaryAction$labe = secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.label) !== null && _secondaryAction$labe !== void 0 ? _secondaryAction$labe : 'Close')
        }), primaryAction && !primaryAction.isHidden && _jsx(Button, {
          iconLeft: (_primaryAction$icon = primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.icon) !== null && _primaryAction$icon !== void 0 ? _primaryAction$icon : null,
          isDisabled: (_primaryAction$isDisa = primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.isDisabled) !== null && _primaryAction$isDisa !== void 0 ? _primaryAction$isDisa : false,
          isLoading: (_primaryAction$isLoad = primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.isLoading) !== null && _primaryAction$isLoad !== void 0 ? _primaryAction$isLoad : false,
          onClick: function onClick() {
            if (legacyOnSubmit) {
              legacyOnSubmit();
            } else if (primaryAction.onClick) {
              primaryAction.onClick();
            } else {
              return null;
            }
          },
          variant: (_primaryAction$varian = primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.variant) !== null && _primaryAction$varian !== void 0 ? _primaryAction$varian : 'tertiary',
          children: legacySubmitButtonLabel || ((_primaryAction$label = primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.label) !== null && _primaryAction$label !== void 0 ? _primaryAction$label : 'Save and Close')
        })]
      })]
    })]
  }));
});
export default Header;